import "./BookAppointment.module.css";
import Header from "@/reusable_sections/Header";
import SecureYourSlot from "./sections/SecureYourSlot";
import OurServiceArea from "./sections/OurServiceArea";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function BookAppointmentPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <main className="flex-1">
        <SecureYourSlot />
        <OurServiceArea />
        <CommonQuestions />
      </main>
      <Footer />
    </div>;
}